export const config = {
  AUTH_ROLE_TYPE: 'LocalAreaManager',
  AUTH_ROLES_ALLOWED: 'Admin,Manager',
  TOKEN_ERROR_MESSAGE: 'token not found',
};

export const getConfig = (key = '') => config[key];

export default config;
